import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { NavLink } from "react-router-dom";
import { loginUser } from "../services/authApi";
import { useMutation } from "@tanstack/react-query";
import '../styles/Login.css'
import Layout from "../components/Layout";
import Input from "../components/Input";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { login } = useAuth();

  const loginMutation = useMutation({
    mutationFn: loginUser,
    onSuccess: () => {
      login();
    },
    onError: (error) => {
      console.log(error);
    }
  });


  const handleSubmit = (e) => {
    e.preventDefault();
    loginMutation.mutate({
      email,
      password,
    });
  };

  return (
    <Layout>
      <div className="login">
        <h1 style={{ margin: "0px auto" }}>Log in</h1>
        <br />

        <button
          className="googleBtn"
          onClick={() =>
            window.location.href =
            // "http://localhost:5000/api/auth/google?redirect=store"
            "https://mern-bookstore-backend-o6qf.onrender.com/api/auth/google?redirect=store"
          }
        >
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            width="18"
          />
          Continue with Google
        </button>
        <br />
        <p style={{ margin: "0px auto", color: "#555" }}>or</p>
        <br />
        <h5>Demo</h5>
        <div>
          <h5 style={{fontWeight:500}}>Email: <span style={{fontWeight:"400",color:'#777'}}>demo@bookstore.com</span></h5>
          <h5 style={{fontWeight:500}}>Pass&nbsp;: <span style={{fontWeight:"400",color:'#777'}}>Demo@1234</span></h5>
        </div>
        <form onSubmit={handleSubmit}>
          <Input type={"email"} name={email} placeholder={"Email"} value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input type={"password"} name={password} placeholder={"Password"} value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} />
          <br />
          {loginMutation.error && (
            <><p style={{ color: "red", margin: "0px auto" }}>{loginMutation.error.response.data.message}</p><br /></>
          )}
          <button type="submit" disabled={loginMutation.isPending}>
            {loginMutation.isPending ? "Logging up..." : "Log in"}
          </button>
          <br />
          <span style={{ margin: "0px auto", color: "var(--primary-color)" }}>Forget Password?</span>
          <br />
          <p style={{ margin: "0px auto", color: "#999" }}>No account ? <NavLink to={'/register'} style={{ margin: "10px auto", color: "var(--primary-color)" }}>Create</NavLink> </p>

        </form>
      </div>
    </Layout>
  );
};

export default Login;
